// extracted by mini-css-extract-plugin
export default {"container":"EditingOrganizationSummary-module__container--_haVO","buttons":"EditingOrganizationSummary-module__buttons--_oyH1"};